<template>
  <div class="select">
    <el-dialog title="选择活动"
               :visible.sync="dialogVisible"
               width="86%"
               :before-close="handleClose">
      <el-form ref="form"
               :model="form"
               :rules="rules"
               label-width="100px">
        <el-form-item label="活动主题："
                      prop="theme">
          <el-select v-model="form.theme"
                     placeholder="请选择活动主题"
                     style="width: 300px"
                     @change="getName">
            <el-option label="拼团"
                       value="2"></el-option>
            <el-option label="订单返现"
                       value="3"></el-option>
            <el-option label="接龙购"
                       value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级主题："
                      prop="secondary">
          <el-select v-model="form.secondary"
                     placeholder="请选择二级主题"
                     @change="getSkuList"
                     style="width: 300px">
            <el-option :label="item.name"
                       v-for="(item, index) in option_name"
                       :value="item.id"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="sku商品：">
          <el-table ref="table"
                    :data="skuGoods"
                    border
                    :row-key="getRowKeys"
                    @selection-change="handleSelectionChange">
            <el-table-column type="selection"
                             width="55"
                             align="center"
                             :reserve-selection="true"> </el-table-column>
            <el-table-column prop="name"
                             align="center"
                             label="商品名称"
                             :show-overflow-tooltip="true"> </el-table-column>

            <el-table-column align="center"
                             prop="img_url"
                             label="sku图"
                             width="130">
              <template slot-scope="scope">
                <el-avatar shape="square"
                           :size="60"
                           fit="cover"
                           :src="scope.row.img_url"></el-avatar>
              </template>
            </el-table-column>
            <el-table-column prop="id"
                             align="center"
                             label="商品skuid"> </el-table-column>

            <el-table-column prop="price_sell"
                             align="center"
                             label=" sku销售价">
            </el-table-column>
            <el-table-column prop="merchandise_inventory"
                             align="center"
                             label=" sku库存">
            </el-table-column>

            <el-table-column prop="max_sales_num"
                             align="center"
                             label=" 最大销量">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.max_sales_num"></el-input>
              </template>
            </el-table-column>
            <!-- 
                       接龙
                      -->
            <el-table-column align="center"
                             label="奖励比例"
                             width="140"
                             v-if="form.theme==1||form.theme==3">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.reward_share"
                          :disabled="Number(scope.row.reward_share) == '' && Number(scope.row.reward_cash) != ''"
                          @change="inputButton1(scope.row)">
                  <template slot="append">%</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column align="center"
                             label="奖励金额"
                             width="140"
                             v-if="form.theme==1||form.theme==3">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.reward_cash"
                          :disabled="Number(scope.row.reward_cash) == '' && Number(scope.row.reward_share) != ''"
                          @change="inputButton2(scope.row)">
                  <template slot="append">元</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column align="center"
                             label="活动价"
                             v-if="form.theme==1">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.price"></el-input>
              </template>
            </el-table-column>

            <el-table-column prop="price"
                             align="center"
                             label="拼团价"
                             v-if="form.theme==2">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.price"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center"
                             label="团长价"
                             v-if="form.theme==2&&is_open_leader_price==1">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.leader_price"></el-input>
              </template>
            </el-table-column>
          </el-table>

        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose"
                   size="small">取 消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data () {
    return {
      btnLoad: false,
      dialogVisible: false,
      spuitem: {},
      obj: [],
      form: {
        theme: "",
        secondary: "",
      },
      is_open_leader_price: 0,
      rules: {
        theme: [{ required: true, message: "请选择活动主题", trigger: "change" }],
        secondary: [{ required: true, message: "请选择二级主题", trigger: "change" }],
      },
      option_name: [],
      type: "",
      checkids: '',
      skuGoods: [],
      multipleSelection: []
    };
  },
  props: {
    oneData: {
      type: Array,
      default: () => {
        return [];
      },
    },

    manyData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    skuData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  methods: {
    ...mapActions({
      getActivityName: "commodity/getActivityName",
      goodsCheck: "commodity/goodsCheck",
      SkuList: "commodity/SkuList",
    }),
    getRowKeys (row) {
      return row.id;
    },
    handleSelectionChange (val) { this.multipleSelection = val; console.log(val, 'val--') },
    inputButton1 (item) { item.disabled2 = true },
    inputButton2 (item) { item.disabled1 = true },
    handleClose () {
      this.dialogVisible = false;
      this.is_open_leader_price = 0
      this.option_name = []
      this.skuGoods = []
      this.obj = []
      this.$refs.form.resetFields();
      this.form = {
        theme: "",
        secondary: "",
      };
    },
    getName () {
      console.log(1)
      this.skuGoods = []
      this.form.secondary = "";
      let params = {
        token: this.getToken,
        type: this.form.theme,
      };
      this.getActivityName(params).then((res) => {
        if (res.code == 1) {
          this.option_name = res.data;

        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getSkuList () {
      let arr = this.option_name.filter((item) => {
        return this.form.secondary == item.id
      })
      this.is_open_leader_price = arr[0].is_open_leader_price
      console.log(arr, 'brr---', this.form.secondary)
      /* this.skuGoods = [] */
      let params = {
        token: this.getToken,
        spu_id: this.checkids,
        activity_id: this.form.secondary
      };
      this.SkuList(params).then((res) => {
        if (res.code == 1) {
          this.obj = []
          this.option_name.forEach(el => {
            if (el.id == this.form.secondary) return this.obj.push(el)

          })
          res.data.list.forEach(el => {
            el.reward_cash = this.obj[0].reward_cash ? this.obj[0].reward_cash : ''
            el.reward_share = this.obj[0].reward_share ? this.obj[0].reward_share : ''
            el.max_sales_num = 0
            el.price = this.obj[0].activity_price ? this.obj[0].activity_price : ''
            el.leader_price = 0
            el.disabled1 = false
            el.disabled2 = false
            /* activity_price */
          })
          this.skuGoods = res.data.list;
          console.log(this.skuGoods, ' this.skuGoods')
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    submit () {


      /** @params老版本裂变工具  
       * let sArr = JSON.parse(JSON.stringify(this.skuData));
       let mArr = JSON.parse(JSON.stringify(this.manyData));
       mArr.forEach((item) => {
         sArr = sArr.filter((val) => {
           return Number(item.spuId) != Number(val.spuId);
         });
       });
       let type = JSON.parse(JSON.stringify(this.form.theme)); */
      let arrList = []
      this.multipleSelection.forEach((elt) => {
        this.skuGoods.forEach(el => {
          if (elt.id == el.id) {
            arrList.push(el)
          }

        })

      })
      if (this.multipleSelection.length == 0) {
        this.$message.error('请勾选参加活动的 sku商品');
      } else {
        this.btnLoad = true;
        let arr = []
        arrList.forEach(el => {
          let obj = {
            product_id: el.goods_id,
            product_sku_id: el.id,
            max_sales_num: el.max_sales_num,
            img_url: el.img_url,
            shop_id: el.shop_id,

          }
          if (this.form.theme == 1) {
            obj.reward_share = el.reward_share
            obj.reward_cash = el.reward_cash
            obj.price = el.price
          }
          else if (this.form.theme == 2) {
            obj.leader_price = el.leader_price
            obj.price = el.price

          } else {
            obj.reward_share = el.reward_share
            obj.reward_cash = el.reward_cash

          }
          arr.push(obj)
        })
        let params = {
          token: this.getToken,
          type: this.form.theme,
          activitys_mains_id: this.form.secondary,
          goods: arr,
          start_time: this.obj[0].start_time,
          end_time: this.obj[0].end_time,
          /*  */

        };
        this.goodsCheck(params).then((res) => {
          this.btnLoad = false;
          if (res.code == 1) {
            this.handleClose();
          } else {
            this.$message.error(res.msg);
          }
        });
        /**@params老版本  this.goodsCheck(params).then((res) => {
          this.btnLoad = false;
          if (res.code == 1) {
            this.$emit("setProductShow", res.data.activityInfo, res.data.productList, type);
            this.handleClose();
          } else {
            this.$message.error(res.msg);
          }
        }); */
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  padding: 40px 0;
}
</style>
